export default {
  // 页面标题
  pageTitle: "地址监控",

  // 按钮
  addMonitor: "添加监控",
  finish: "完成",
  reset: "重置",
  query: "查询",
  view: "查看",
  modify: "修改",
  confirm: "确定",
  cancel: "取消",
  yes: "是",
  no: "否",

  // 输入框占位符
  inputMonitorName: "请输入监控名称",
  inputMonitorAddress: "请输入监控地址",
  selectRelatedCase: "请选择关联案件",
  selectCurrency: "请选择币种",

  // 标题信息
  totalMonitors: "条地址监控",
  monitoring: "监控中",
  totalCount1:"共",
  totalCount: "条",
  hideStoppedData: "隐藏暂停监控数据",

  // 监控类型
  commonMonitor: "普通监控",
  realtimeMonitor: "实时监控",

  // 监控信息
  monitorName: "监控名称",
  address: "地址",
  relatedCase: "关联案件",
  condition: "条件",
  remark: "备注",
  monitorDynamics: "条监控动态",
  unread: "条未读",

  // 对话框标题
  dialogAddMonitor: "添加监控",
  dialogModify: "修改",
  dialogDingTalkHelp: "钉钉添加机器人操作说明",

  // 提示信息
  noData: "暂无数据",
  loading: "拼命加载中",
  copySuccess: "复制成功",
  modifySuccess: "修改成功",
  deleteSuccess: "删除监控成功",
  deleteCancel: "已取消删除",

  // 确认对话框
  confirmDelete: "此操作将永久删除该文件, 是否继续?",
  confirmStop: "是否变更状态为",
  stopMonitor: "关闭监控",
  openMonitor: "打开监控",
  closeSuccess: "关闭监控成功",

  // 详情页面
  detailTitle: "详情",
  transferIn: "转入",
  transferOut: "转出",
  amount: "金额",
  time: "时间",
  hash: "hash",

  // 提示
  tip: "提示",
  multiChainTip: "当前地址存在多个链交易数据，请选择下方应对链进行分析",
};
